export const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
export const isSB = process.env.STORYBOOK === 'true';
export const RESPONSIVE_CARD_SWITCH_BREAKPOINT = 480;
export const EMPTY_OBJECT = {};
